<template>
  <div :class="$style['filters']">
    <FiltersSort
      v-if="filterStore.available.sort"
      :title="$t('general/filter-sortby')"
      :available="filterStore.available.sort"
      :active="filterStore.active.sort"
      @toggle="
        value =>
          filterStore.toggle({
            filter: 'sort',
            value
          })
      " />
    <FiltersGroups />
    <FiltersPrice />
    <FiltersSizes />
    <FiltersColors />

    <FiltersComingSoon
      v-if="filterStore.available.available"
      :title="$t('general/filter-available')"
      :subtitle="$t('general/filter-hide-coming-soon')"
      :active="!!filterStore.active.available"
      @toggle="
        value =>
          filterStore.toggle({
            filter: 'available',
            value
          })
      " />
  </div>
</template>
<script setup>
const filterStore = useFilterStore()
</script>
<style lang="scss" module>
.filters {
  color: $black;
  display: grid;
  grid-gap: $spacing * 2;
}
</style>
